// MBTI 人格類型字典（Phase 1.94）— 單一事實來源
// 元件一律從此檔取得類型清單與配色，不得寫死

export const MBTI_TYPES = [
  'INTJ', 'INTP', 'ENTJ', 'ENTP',
  'INFJ', 'INFP', 'ENFJ', 'ENFP',
  'ISTJ', 'ISFJ', 'ESTJ', 'ESFJ',
  'ISTP', 'ISFP', 'ESTP', 'ESFP'
];

// 四大群組（沿用 16personalities 慣例，彩度調淡以貼合 App 藍色主題）
export const MBTI_GROUPS = {
  analyst: {
    label: '分析家',
    types: ['INTJ', 'INTP', 'ENTJ', 'ENTP'],
    bg: '#ede9fe',
    color: '#6d28d9'
  },
  diplomat: {
    label: '外交官',
    types: ['INFJ', 'INFP', 'ENFJ', 'ENFP'],
    bg: '#d1fae5',
    color: '#047857'
  },
  sentinel: {
    label: '守護者',
    types: ['ISTJ', 'ISFJ', 'ESTJ', 'ESFJ'],
    bg: '#dbeafe',
    color: '#1d4ed8'
  },
  explorer: {
    label: '探險家',
    types: ['ISTP', 'ISFP', 'ESTP', 'ESFP'],
    bg: '#fef3c7',
    color: '#b45309'
  }
};

// 取得指定 MBTI 的標籤配色；未知/空值回傳 null（呼叫端據此不渲染）
export const getMbtiStyle = (mbti) => {
  if (!mbti) return null;
  const group = Object.values(MBTI_GROUPS).find(g => g.types.includes(mbti));
  return group ? { bg: group.bg, color: group.color } : null;
};
